import { type StoreDefinition, type Pinia, type StateTree, getActivePinia } from 'pinia'
import { getRegisteredPinia } from './appRuntime'

export function wrapStoreWithActivePinia<Id extends string, S extends StateTree, G, A>(
  storeDefinition: StoreDefinition<Id, S, G, A>
) {
  return (pinia?: Pinia) => {
    const piniaInstance = pinia || getActivePinia() || getRegisteredPinia()

    if (!piniaInstance) {
      throw new Error('Pinia is not initialized. Make sure to install pinia in the app before using it in a library.')
    }

    return storeDefinition(piniaInstance)
  }
}
